import { TermModel } from 'models/term';

export default function getPayload(term: TermModel) {
  return term;
}
